module.exports = __webpack_public_path__ + "static/media/1023261.61b999d6.png";